<div class="fixed inset-0 z-50 flex items-center justify-center">
	<div class="lds-ring">
		<div />
		<div />
		<div />
		<div />
	</div>
</div>
